/**
 * InvalidState — page anti-leak unique 9.N.2 v2.
 *
 * Affichée pour TOUTE défaillance token-level :
 *   - GET metadata `kind:"invalid"` (200 ok:false PUBLIC_INTAKE_LINK_UNAVAILABLE
 *     — token-level : forgé / révoqué / expiré / quota / DB miss /
 *     project soft-deleted / project_title null).
 *   - GET metadata `kind:"error"` (réseau / shape inattendue / 429 rate-limit).
 *   - POST submission `kind:"invalid"` (race quota détectée post-claim,
 *     honeypot triggered).
 *
 * Wire/UI message UNIQUE — l'utilisateur final ne distingue pas "lien forgé"
 * / "lien révoqué" / "lien expiré" / "API down". Couverture anti-énumération
 * cadrage F2 §6.
 *
 * Pas de stack, pas de details techniques, pas de bouton "réessayer" qui
 * laisserait entendre du transitoire (un lien révoqué l'est définitivement).
 *
 * Parité visuelle stricte avec `<SuccessState>` : même chrome, même taille
 * pastille (h-14 w-14), même typo. Seul le glyphe + la couleur de la pastille
 * + le texte changent. La pastille ⓘ amber est volontairement *non-anxiogène*
 * (signal informatif neutre, pas warning ⚠) — on demande au client de
 * contacter son courtier, pas de paniquer.
 */

import { useTranslation } from "react-i18next";

export function InvalidState(): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-7 text-center shadow-[0_1px_2px_rgba(15,23,42,0.04),0_8px_24px_-12px_rgba(15,23,42,0.08)] motion-safe:animate-fade-in sm:p-10">
      <div
        aria-hidden="true"
        className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-amber-50 ring-8 ring-amber-50/40"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          className="h-7 w-7 text-amber-600"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12"
            cy="12"
            r="9"
            stroke="currentColor"
            strokeWidth="1.75"
          />
          <path
            d="M12 11.25v5"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
          />
          <circle cx="12" cy="8" r="1" fill="currentColor" />
        </svg>
      </div>
      <h1 className="mt-5 text-2xl font-semibold tracking-tight text-slate-900 sm:text-[26px]">
        {t("public_intake.states.invalid.title")}
      </h1>
      <p className="mx-auto mt-2 max-w-sm text-pretty text-sm text-slate-600">
        {t("public_intake.states.invalid.body")}
      </p>
    </div>
  );
}
